export default __webpack_public_path__ + "static/media/classAttribute.0c685472.png";